// extracted by mini-css-extract-plugin
module.exports = {"item":"K_c3","item__image":"K_c4"};